import { makeStyles } from "@material-ui/core";

export default makeStyles(
  () => ({
    root: {
      minHeight: "100%",
      paddingTop: 8,
      paddingBottom: 46,
    },
  }),
  { name: "UpdateCreditCard" },
);
